// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nnVy","col":"styles_col__3-5Mz"};